// This file is the entry point for browser bundles
import { getDefaultClient, setDefaultClient } from "../Client.js";
import { DataHandler, DataProviderHandler, DataProviderHandlerAPI, SortOrder } from "../DataHandler.js";
import { DataObject } from "../DataObject.js";
import { FileUploader } from "../FileUploader.js";
import { Paging } from "../Paging.js";
import { Procedure, ProcedureAPI } from "../Procedure.js";
import { MemoryStorage, uid } from "../Storage.js";
import { Client } from "../browser/Client.js";
import { generateApiDataHandler, generateApiDataObject } from "../generateApiDataObject.js";

export {
	Client,
	DataObject,
	DataHandler,
	DataProviderHandlerAPI,
	DataProviderHandler,
	FileUploader,
	generateApiDataHandler,
	generateApiDataObject,
	getDefaultClient,
	setDefaultClient,
	MemoryStorage,
	Paging,
	Procedure,
	ProcedureAPI,
	SortOrder,
	uid,
};

export const version = __VERSION__;
